import { useCallback, useEffect, useState } from "react";
import "../../styles/fuzzy/fuzzyRange.css";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";
import { ExpandingTooltip } from "../tooltips/ExpandingTooltip";

export { RangeInput, Props as RangeInputProps };

type Props = {
  className?: string;
  /** Default to 50 */
  min?: number;
  /** Default to 100 */
  max?: number;
  /**
   * Control whether a number input should be created
   * TODO: better name, like interactiveLabel, or flip usage and call readOnlyLabel ?
   */
  inputLabel?: boolean;
  /**
   * Label in <span>
   */
  label: string;
  value: number;
  /**
   * Called by an <input type="range" /> node's onChange handler
   */
  onMove(value: number): void;
  /**
   * Called by an <input type="range" /> node's onBlur handler
   */
  onChange(value: number): void;

  tProps?: ExpandingTooltipReturn["triggerProps"];
};

const RangeInput = (props: Props) => {
  const [valueStr, setValueStr] = useState(props.value + "");

  const parseValue = useCallback(() => {
    let val = parseInt(valueStr);
    if (Number.isNaN(val)) {
      return;
    }
    if (val < min) {
      val = min;
    } else if (val > max) {
      val = max;
    }
    // setValue(val);
    return val;
  }, [valueStr]);

  // call onMove when value changes to valid value
  useEffect(() => {
    const valueInt = parseValue();
    if (valueInt && valueInt !== props.value) {
      props.onMove(valueInt);
    }
  }, [parseValue, props.onMove]);

  const parseAndChange = useCallback(() => {
    const parsed = parseValue();
    if (parsed != undefined) {
      props.onChange(parsed);
    }
  }, [parseValue, props.onChange]);

  const min = props.min ?? 50,
    max = props.max ?? 100;

  return (
    <div {...props.tProps} className={`${props.className ?? ""}`}>
      {/* generate input label  */}
      {props.inputLabel && (
        <input
          type={"number"}
          value={valueStr}
          // TODO: test that pressing enter on this input closes popup!
          onBlur={() => {
            parseAndChange();
          }}
          onKeyDown={({ key }) => {
            if (key !== "Enter") return;
            const valueInt = parseValue();
            if (valueInt) {
              parseAndChange();
            } else {
              // reset if value invald
              setValueStr(props.value + "");
            }
          }}
          // handle NaN
          onChange={(e) => {
            setValueStr(e.target.value);
          }}
        />
      )}
      {/* text label */}
      {!props.inputLabel && <span>{props.label}</span>}
      <input
        type={"range"}
        step={1}
        min={min}
        max={max}
        value={valueStr}
        // TODO: test that pressing enter on this input closes popup!
        onBlur={() => {
          parseAndChange();
        }}
        onKeyDown={({ key }) => key === "Enter" && parseAndChange()}
        // handle NaN
        onChange={(e) => {
          // let val = parseInt(e.target.value);
          // if (Number.isNaN(val)) {
          //     return;
          // }
          // if (val < min) {
          //     val = min;
          // } else if (val > max) {
          //     val = max;
          // }
          setValueStr(e.target.value);
        }}
      />
    </div>
  );
};
